export default __webpack_public_path__ + "static/media/connecting-plug.51868411.svg";